import styled from 'styled-components';
import IconChevronDownOutline from './IconChevronDownOutline';
var IconChevronRightOutline = /*#__PURE__*/styled(IconChevronDownOutline).withConfig({
  displayName: "IconChevronRightOutline",
  componentId: "c11n-8-107-0__sc-1yzayyv-0"
})(["transform:rotate(270deg);"]);
export default IconChevronRightOutline;